import { Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import hdate from 'human-date';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { getMemberPriceStampInfoFromMemberName } from '../../../lib/utils';
import { getTranslationFromHDateRelativeTime } from '../../../lib/utils/formatDateTime';
import { OUTDATED_PRICE_DISPLAY } from '../../constants';
import styles from './FuelTypePriceDisplay.module.css';

const cx = classnames.bind(styles);

export default function FuelTypePriceDisplay({ cash, priceInfo }) {
  const { t } = useTranslation(['miscellaneous', 'dates']);
  const { nickname, formattedPrice, postedTime: timestamp } = priceInfo;
  const priceStampInfo = getMemberPriceStampInfoFromMemberName(nickname);

  return (
    <Fragment>
      <Text bold className={cx('price', { cash })} size="xl">
        {formattedPrice}
      </Text>
      {formattedPrice !== OUTDATED_PRICE_DISPLAY && (
        <div className={cx('reportedBy', 'reportedGrey')}>
          <a href={priceStampInfo.linkUrl}>
            <Text className={cx('reportedGrey')} size="sm">
              <img src={priceStampInfo.iconPath} alt={t('icons.member', { ns: 'miscellaneous' })} />
              &nbsp;
              {nickname}
            </Text>
          </a>
          <br />
          <Text as="p" className={cx('reportedTime', 'reportedGrey')} size="sm">
            {getTranslationFromHDateRelativeTime(hdate.relativeTime(timestamp), t)}
          </Text>
        </div>
      )}
    </Fragment>
  );
}

FuelTypePriceDisplay.propTypes = {
  cash: PropTypes.bool,
  priceInfo: PropTypes.shape({
    nickname: PropTypes.string,
    formattedPrice: PropTypes.string,
    postedTime: PropTypes.string,
  }),
};

FuelTypePriceDisplay.defaultProps = {
  cash: false,
  priceInfo: {
    nickname: undefined,
    postedTime: undefined,
    formattedPrice: OUTDATED_PRICE_DISPLAY,
  },
};
